import { Button, Grid, InputLabel, Typography } from '@mui/material';
import images from 'assets/images';
import React from 'react';
import { Container } from '@mui/system';
import { joinUsTimeLineObj } from 'assets/animation/portalAnimation';
import { Field, Formik } from 'formik';
import { IEnquiryModel } from 'models/enquiry';
import { toast } from 'react-toastify';
import enquiryService from 'services/home/home-service';
import { HttpStatusCode } from 'shared/enums/http-status-code';
import messages from 'shared/constants/messages';
import { EnquiryFormValidationSchema } from 'validations/public/enquiry';
import { FormikInput } from 'shared/material-ui-formik';

const EnquiryForm: React.FC = () => {
    const joinUsTimeLine = React.useRef(null);
    const initialState: IEnquiryModel = {
        id: 0,
        name: '',
        email: '',
        mobile: '',
        postCode: '',
        enquiryArea: '',
        createdDate: null,
    };

    React.useEffect(() => {
        joinUsTimeLineObj(joinUsTimeLine);
    }, []);

    const handleSubmit = async (data: IEnquiryModel) => {
        await enquiryService
            .addEnquiry(data)
            .then((response) => {
                const { statusCode, message } = response?.data;
                if (statusCode === HttpStatusCode.Success) {
                    toast.success(messages.EnquirySentSuccess);
                } else toast.warn(message);
            })
            .catch(() => toast.error(messages.SomethingWentWrong));
    };

    return (
        <section className="join-us" ref={joinUsTimeLine}>
            <Container maxWidth="lg">
                <Grid container spacing={2}>
                    <Grid item xs={12} lg={7} order={{ xs: 2, lg: 1 }}>
                        <div className="join-us-form">
                            <Typography variant="h3" className="section-title">
                                Join one of the fastest growing telehealth platforms
                            </Typography>
                            <Typography variant="body2" className="section-info">
                                Let us show you a better, cheaper way to run telehealth clinics
                            </Typography>
                            <Formik
                                initialValues={initialState}
                                onSubmit={async (values, { resetForm }) => {
                                    await handleSubmit(values);
                                    resetForm();
                                }}
                                validateOnChange={true}
                                enableReinitialize={true}
                                validationSchema={EnquiryFormValidationSchema}
                            >
                                {(props) => {
                                    const { handleSubmit } = props;
                                    return (
                                        <form onSubmit={handleSubmit}>
                                            <div className="form">
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} md={6}>
                                                        <Field
                                                            inputlabel="Name"
                                                            type="text"
                                                            name="name"
                                                            id="name"
                                                            maxLength={100}
                                                            component={FormikInput}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <Field
                                                            inputlabel="Email"
                                                            type="text"
                                                            name="email"
                                                            id="email"
                                                            maxLength={150}
                                                            component={FormikInput}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <Field
                                                            inputlabel="Mobile"
                                                            type="text"
                                                            name="mobile"
                                                            id="mobile"
                                                            maxLength={20}
                                                            component={FormikInput}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <Field
                                                            inputlabel="Postcode"
                                                            type="text"
                                                            name="postCode"
                                                            id="postCode"
                                                            maxLength={10}
                                                            component={FormikInput}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Field
                                                            multiline
                                                            rows={3}
                                                            inputlabel="Area of enquiry"
                                                            type="text"
                                                            name="enquiryArea"
                                                            id="enquiryArea"
                                                            maxLength={-1}
                                                            component={FormikInput}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </div>
                                            <Button
                                                variant="contained"
                                                size="large"
                                                title="Submit for Free Trial"
                                                className="submit-btn"
                                                type="submit"
                                            >
                                                Submit for Free Trial
                                            </Button>
                                        </form>
                                    );
                                }}
                            </Formik>
                        </div>
                    </Grid>
                    <Grid item xs={12} lg={5} order={{ xs: 1, lg: 2 }}>
                        <div className="join-us-mockup">
                            <div className="block-layer">
                                <div className="circle top"></div>
                                <div className="color-layer">
                                    <img src={images.doctorWithTab} alt="Image" className="main-mockup" />
                                </div>
                                <div className="circle bottom"></div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </section>
    );
};

export default React.memo(EnquiryForm);
